import { render, staticRenderFns } from "./MSecondaryDomainMove.vue?vue&type=template&id=5d901548&"
import script from "./MSecondaryDomainMove.vue?vue&type=script&lang=ts&"
export * from "./MSecondaryDomainMove.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports